import { iconsSvg } from './utils';
export default {
  name: 'UploadFileList',
  props: {
    fileArr: {
      type: Array,
      default: () => []
    },
    readonly: {
      type: Boolean,
      default: false
    },
    listType: {
      type: String,
      default: 'text'
    },
    canPreviewAllFile: Boolean
  },
  computed: {
    useYzPreview() {
      return this.canPreviewAllFile || !!window.yzOnlineView;
    }

  },
  methods: {
    showPreview(item) {
      return item.isImage || this.yongzhongPreview(item) || /\.pdf$/.test(item.name.toLowerCase());
    },

    handlePreview(item) {
      this.$emit('handlePreview', item);
    },

    handleRemove(item) {
      this.$emit('handleRemove', item);
    },

    formatFileSize(size) {
      if (size / 1024 < 1024) {
        return (size / 1024).toFixed(1) + ' KB';
      } else {
        return (size / 1024 / 1024).toFixed(1) + ' MB';
      }
    },

    renderIcon(item) {
      let key = 'other';
      const fileName = item.name.toLowerCase();

      if (item.isImage) {
        key = 'image';
      } else if (/\.pdf$/.test(fileName)) {
        key = 'pdf';
      } else if (/\.(?:xls|xlsx)$/.test(fileName)) {
        key = 'excel';
      } else if (/\.(?:doc|docx)$/.test(fileName)) {
        key = 'word';
      } else if (/\.(?:ppt|pptx)$/.test(fileName)) {
        key = 'ppt';
      } else if (/\.(?:zip|7z)$/.test(fileName)) {
        key = 'zip';
      } else if (/\.rar$/.test(fileName)) {
        key = 'rar';
      } else if (/\.(?:mp3|wav|wma)$/.test(fileName)) {
        key = 'music';
      } else if (/\.(?:mpeg|mp4|wmv|avi|mkv)$/.test(fileName)) {
        key = 'media';
      } else {
        key = 'other';
      }

      return iconsSvg[key];
    },

    // 是否启用永忠文件预览
    yongzhongPreview(item) {
      const fileTest = /\.(?:xls|xlsx|ppt|pptx|doc|docx|pdf|txt|zip|rar|ofd|rtf|eio|uof|uos|xml|wps|tif)$/.test(item.name.toLowerCase());
      return item.yongzhongPreview = this.useYzPreview && fileTest;
    }

  }
};